import {Card} from "./Card";
import {User} from "@/entity/User";

export class CardExchange {
  constructor(props = {}) {
    this.id = props.id
    this.memo = props.memo || ''
    this.score = props.score
    this.receivedAt = props.receivedAt
    this.user = new User(props.user || {})
    this.card = new Card(props.card || {})
  }
  export = () => {
    return {
      id: this.id,
      memo: this.memo,
      score: this.score
    }
  }
}
